import * as THREE from 'three'
import Experience from "../Experience"

export default class Tabela
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.time = this.experience.time
        this.debug = this.experience.debug

        if(this.debug.active)
        {
            this.debugFolder = this.debug.ui.addFolder('Tabela')
        }
        
        // Setup
        this.resource = this.resources.items.tabelaModel

        this.setModel()
    }

    setModel()
    {
        this.model = this.resource.scene
        this.model.scale.set(0.01, 0.01, 0.01)
        this.scene.add(this.model)

        this.model.traverse((child) =>
        {
            console.log(child);
            if(child instanceof THREE.Mesh || child instanceof THREE.Group)
            {
                child.castShadow = true
                child.receiveShadow = true
            }

            if(child instanceof THREE.Mesh)
            {
                child.material.metalness = 0
                child.material.roughness = 1
            }
        })
    }
}